export default __webpack_public_path__ + "static/media/home-finance-profits-img.eefd4ffb.jpg";